module.exports = __webpack_public_path__ + "media/images/countryrect/no-b3a8af7d295bb8c36cb2f2819dea4da8.svg";